import { getWeekStart } from '@utils/dates'
import { DateTime, Interval } from 'luxon'
import { useMemo } from 'react'
import { useWeekDatesSearchParams as useWeekDatesSearchParamsImported } from './useWeekDatesSearchParams'

const getRange = (start: DateTime, end: DateTime) =>
  Interval.fromDateTimes(start, end)
    .splitBy({ day: 1 })
    .map((i) => i.start)

interface Options {
  weekStartsOn: 'sunday' | 'monday'
  zone?: string
}

export const useWeekDates = (
  { weekStartsOn, zone }: Options,
  useWeekDatesSearchParams = useWeekDatesSearchParamsImported, // injected for easier testing
) => {
  const { set, start: startParam } = useWeekDatesSearchParams(
    useMemo(() => ({ zone }), [zone]),
  )

  return useMemo(() => {
    const start = getWeekStart({
      date: startParam ?? DateTime.local().setZone(zone),
      weekStartsOn,
    })

    const end = start.plus({ days: 6 }).endOf('day')

    return { start, end, range: getRange(start, end), set }
  }, [startParam, zone, weekStartsOn, set])
}
